import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import Icon from 'Components/Icon';

class AccountDropPanel extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool
  };

  render () {
    const { onClose, children, isOpen } = this.props;

    return (
      <>
        <div
          className={ classnames({
            'account-drop-panel': true,
            'account-drop-panel--open': isOpen
          }) }
        >
          <div className="account-drop-panel__content">
            <Icon iconName="svgClose" className="account-drop-panel__close" onClick={ onClose } />
            <div className="account-drop-panel__header">
              <div className="account-drop-panel__header__logo" />
            </div>
            { children }
          </div>
          <div className="account-drop-panel__overlay" onClick={ onClose } />

        </div>
      </>
    );
  }
}

export default AccountDropPanel;
